export enum FeatureFlag {
  BLOCK_SELF_SERVICE_SIGNUP = 'corps.blockSelfServiceSignup',
  ENABLE_AUTOFILL_CORP = 'corps.enableAutofillCorp',
  ENABLE_COOKBOOK_AUDIT_MODE = 'site.cookbook.enableAuditMode',
  ENABLE_GRUB_API_CORE = 'plex.enableGrubApiCore',
  ENABLE_COOKIE_BASED_AUTH = 'plex.enableCookieBasedAuth',
  SHOW_SSO_ON_NATIVE_OPTION = 'plex.showSsoOnNativeOption',
  ENABLE_REPORTING_FEATURE = 'corps.enableReportingFeature',
  REPORTING_INTERNAL_ONLY_PHASE = 'corps.reportingInternalOnlyPhase',
  BALANCE_POST_LAUNCH_IMPROVEMENTS = 'plex.balancePostLaunchImprovements',
  ENABLE_BUSINESS_INSIGHTS = 'plex.enableBusinessInsights',
}
